import React, {Component} from 'react';
import PolyUtil from '../../../util/PolyUtil';

class CoverImage extends Component {

    render() {
        const background = "linear-gradient("  + this.props.gradStart + "," + this.props.gradEnd + "), url(\"" + this.props.src + "\")"
        return (
            <div
                style={{
                    background: background,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "50% 50%",
                    height: "150px",
                    minHeight: "100%",
                    minWidth: "100%",
                    ...this.props.style
                }}
                className={"pr-card-image " + PolyUtil.nvl(this.props.className, "")}/>

        )
    }
}

CoverImage.defaultProps = {gradStart: "rgba(20,20,20, .5)", gradEnd: "rgba(20,20,20, .5)"};

export default CoverImage;


// WEBPACK FOOTER //
// ./src/components/media/images/CardCoverImage.js